import React, { useState } from 'react';
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
    useTheme,
} from "@mui/material";
import {
    SupportAgentRounded,
} from "@mui/icons-material";
import _SupportNew from "./_SupportNew";
import _SupportInfo from "./_SupportInfo";
import _SupportList from "./_SupportList";

const Support = () => {
    const theme = useTheme();
    const [refreshKey, setRefreshKey] = useState(0);

    const handleTicketCreated = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            <title>پشتیبانی و تیکت‌ها | جیم‌پین سازمانی</title>

            {/* Executive Page Header */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 3.5,
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            width: 54,
                            height: 54,
                            borderRadius: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'primary.main',
                            color: '#fff',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        <SupportAgentRounded sx={{ fontSize: 32 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                            پشتیبانی و تیکت‌ها
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            ثبت درخواست‌های جدید، ارتباط با کارشناسان جیم‌پین و پیگیری وضعیت تیکت‌های سازمان
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ alignSelf: { xs: 'stretch', sm: 'auto' } }}>
                    <_SupportNew onSuccess={handleTicketCreated} />
                </Box>
            </Box>

            {/* Main Content: Tickets List & Support Info Guide */}
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <_SupportList key={refreshKey} />
                </Grid>
                <Grid size={{ xs: 12, lg: 4 }}>
                    <_SupportInfo />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Support;
